const creditCardType = require("credit-card-type");

creditCardType.resetModifications();

const brands = {
	elo: "Elo",
	amex: "American Express",
	diners: "Diners",
	mastercard: "MasterCard",
	visa: "Visa",
	aura: "Aura",
	hipercard: "HiperCard"
};

creditCardType.changeOrder("elo", 0);

creditCardType.removeCard(creditCardType.types.MAESTRO);
creditCardType.removeCard(creditCardType.types.DISCOVER);
creditCardType.removeCard(creditCardType.types.JCB);
creditCardType.removeCard(creditCardType.types.UNIONPAY);
creditCardType.removeCard(creditCardType.types.MIR);

creditCardType.updateCard(creditCardType.types.ELO, {
	niceType: "elo"
});
creditCardType.updateCard(creditCardType.types.AMERICAN_EXPRESS, {
	niceType: "amex"
});
creditCardType.updateCard(creditCardType.types.DINERS_CLUB, {
	niceType: "diners"
});
creditCardType.updateCard(creditCardType.types.MASTERCARD, {
	niceType: "mastercard"
});
creditCardType.updateCard(creditCardType.types.VISA, {
	niceType: "visa"
});

creditCardType.addCard({
	niceType: "hipercard",
	type: "hipercard",
	exactPattern: /^(606282\d{10}(\d{3})?)|(3841(0|4|6)0\d{13})$/,
	prefixPattern: /^(6|3)/,
	gaps: [4, 8, 12],
	lengths: [16, 19],
	code: { name: "CVC", size: 3 }
});

creditCardType.addCard({
	niceType: "aura",
	type: "aura",
	exactPattern: /^50\d{17}$/,
	prefixPattern: /^50/,
	gaps: [4, 8, 12],
	lengths: [16, 17, 18, 19],
	code: { name: "CVC", size: 3 }
});

const creditCardUtils = {
	getBrand: function(creditCardNumber) {
		const number = creditCardNumber.replace(/\D/g, "");
		if (!number) {
			return undefined;
		}
		const [cardDetected] = creditCardType(number);
		return [cardDetected ? cardDetected.niceType : undefined, cardDetected];
	},

	getNiceName: function(brand) {
		return brands[brand] || brand;
	}
};

export default creditCardUtils;
